import { render, staticRenderFns } from "./authManage.vue?vue&type=template&id=2ba23d84&scoped=true&"
import script from "./authManage.vue?vue&type=script&lang=js&"
export * from "./authManage.vue?vue&type=script&lang=js&"
import style0 from "./authManage.vue?vue&type=style&index=0&id=2ba23d84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba23d84",
  null
  
)

export default component.exports